import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { TALENT_DOCKER_API_URL } from "../../../constants";
import { useOrganizationSlug } from "./use-organization-slug";
export var useLearning = function useLearning(_ref) {
  var email = _ref.email;
  var BASE_URL = TALENT_DOCKER_API_URL;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    error = _useState6[0],
    setError = _useState6[1];
  var _useOrganizationSlug = useOrganizationSlug({
      email: email
    }),
    learningOrgSlug = _useOrganizationSlug.organizationSlug,
    myRole = _useOrganizationSlug.myRole,
    isB2BAllCatalog = _useOrganizationSlug.isB2BAllCatalog,
    isB2BOnlyPanel = _useOrganizationSlug.isB2BOnlyPanel;
  useEffect(function () {
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (!email) return;
    var fetchData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var url, response, jsonData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              url = "".concat(BASE_URL, "/learningintegration/users/").concat(email, "/hasLearning");
              _context.prev = 1;
              _context.next = 4;
              return fetch(url);
            case 4:
              response = _context.sent;
              if (response.ok) {
                _context.next = 7;
                break;
              }
              throw new Error('Network response was not ok');
            case 7:
              _context.next = 9;
              return response.json();
            case 9:
              jsonData = _context.sent;
              setData(jsonData);
              setLoading(false);
              _context.next = 18;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](1);
              // @ts-expect-error to be defined later
              setError(_context.t0);
              setLoading(false);
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 14]]);
      }));
      return function fetchData() {
        return _ref2.apply(this, arguments);
      };
    }();
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [email]);
  return {
    isLearningModuleActive: data,
    loading: loading,
    error: error,
    learningOrgSlug: learningOrgSlug,
    myRole: myRole,
    isB2BAllCatalog: isB2BAllCatalog,
    isB2BOnlyPanel: isB2BOnlyPanel
  };
};